import * as React from "react";
const SvgBin20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 16,
        fill: "black",
        viewBox: "0 0 20 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6 0H0v16h20V0h-6v2H6V0Zm10 4V2h2v12H2V2h2v2h12Zm-3 2v6h2V6h-2Zm-4 6V6h2v6H9ZM5 6v6h2V6H5Z",
      clipRule: "evenodd"
    })
  );
export default SvgBin20Px;
